import {Component, OnInit, Input, ChangeDetectorRef, HostListener, OnDestroy, ViewChild} from '@angular/core';
import { TextboxModel } from '../textbox.model';
import { Subject } from 'rxjs';
import { WorkflowComponentsService } from '../../workflow-components.service';
import { takeUntil } from 'rxjs/operators';
import { Model_WorkflowComponent } from 'src/app/app.models';
import { TextBoxComponent } from '@progress/kendo-angular-inputs';

@Component({
    selector: 'abw-textbox-design',
    templateUrl: './textbox-design.component.html',
    styleUrls: ['./textbox-design.component.scss']
})
export class TextboxDesignComponent implements OnInit, OnDestroy {
    isComponentSelected = false;
	@Input() model: TextboxModel;
    @Input() value: any;
    onComplete = new Subject();
    @ViewChild('kTextbox') public textbox: TextBoxComponent;

    constructor(
        private _workflowComponentsService: WorkflowComponentsService,
        private _cdf: ChangeDetectorRef
    ) {
    }

    ngOnInit() {
        this._workflowComponentsService.workflowDesignerComponentSelected$.pipe(takeUntil(this.onComplete)).subscribe(_selectedComponent => {
            this.isComponentSelected = _selectedComponent != null && _selectedComponent.GUID == this.model.additional.GUID;
            this._cdf.detectChanges();
        });
    }

    @HostListener("click") onClick(){
        const base_component = this.model.additional as Model_WorkflowComponent;
        base_component.PROPERTIES = this.value;
        this._workflowComponentsService.workflowDesignerComponentSelected$.next(base_component);
    }

    ngOnDestroy() {
        this.onComplete.next();
        this.onComplete.complete();
    }

    getInputType() {
          const workflowComponent = (this.model as any).additional as Model_WorkflowComponent;
      if (workflowComponent.INPUT_TYPE == 'password') {
        return 'password';
      }
      return 'text';
    }
}